var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper main-wrapper-1",attrs:{"id":"mainWrapper"}},[(_vm.isInit)?[_c('Message'),_c('router-view')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }